// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-6564cd2d]{list-style:none;padding:0;height:200px;overflow-y:scroll}li[data-v-6564cd2d]{padding:4px 10px;font-size:14px;cursor:pointer}p[data-v-6564cd2d]{top:-21px;left:30px}.fa-solid[data-v-6564cd2d],p[data-v-6564cd2d]{position:absolute}.fa-solid[data-v-6564cd2d]{top:150px;font-size:16pt;left:-12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
